import styled from '@emotion/styled'
import { color, space, shadow } from '@ticketswap/solar'
import { Envelope, Checkmark } from '@ticketswap/solar/icons'

const IconContainer = styled.div`
  position: relative;
  color: ${color.earth};
  background-color: ${color.actionBackground};
  width: ${space[96]};
  height: ${space[96]};
  border-radius: ${space[48]};
  display: flex;
  justify-content: center;
  align-items: center;
`

const Adornment = styled.span`
  position: absolute;
  inset-inline-end: 0;
  inset-block-end: 0;
  background-color: ${color.background};
  box-shadow: ${shadow.strong};
  width: ${space[32]};
  height: ${space[32]};
  border-radius: ${space[32]};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${color.success};
`

const EmailSent = () => (
  <IconContainer>
    <Envelope size={64} />
    <Adornment>
      <Checkmark size={24} />
    </Adornment>
  </IconContainer>
)

export default EmailSent
